export default "__VITE_ASSET__CAL_dv$g__"